import type { HeroKey } from '@wl/theme';

/** The brand fields `heroFor` needs — a subset of TenantBrand, so this stays client-safe. */
interface HeroBrand {
  isDefault: boolean;
  heroes: Partial<Record<HeroKey, string>>;
}

/**
 * The hero image for a vertical home page:
 *   the tenant's own image → BookItPlease's current image (default tenant only) → undefined.
 *
 * Undefined means "render the brand-gradient fallback" (`.brand-hero-fallback`): BookItPlease's
 * artwork carries its purple, and on the hotels banner its slogan, so it is never shown under
 * another tenant's brand.
 */
export function heroFor(brand: HeroBrand, key: HeroKey, platformImage: string | undefined): string | undefined {
  return brand.heroes[key] ?? (brand.isDefault ? platformImage : undefined);
}
